import React from 'react';
import { list } from "@randajan/jet-core/eachSync";
import "./Diagram.scss";

// @ts-ignore - Resolved by import-glob plugin during build.
import * as files from "./fragments/**/*";

import { importFiles } from "@randajan/simple-app/fs";
import { useInView } from 'react-intersection-observer';
import { Img } from '../Img/Img';

const fragments = importFiles(files, { prefix:"./fragments/", suffix:".png" });


export const Diagram = (props)=>{
    const {} = props;

    const [ref, inView] = useInView({triggerOnce:true, threshold: .8});
    
    return (
        <div ref={ref} className={`Diagram ${inView ? "isActive" : "isPasive"}`}>
            <div className="fragments">
                {list(fragments, (f, {key})=><Img key={key} src={f} className={"d"+key.slice(8)}/>)}
            </div>
        </div>
    )
}

